import React from "react";

const NoteForSalesUnit = () => {
  return (
    <div className="note-main">
      <section className="note-section">
        <div className="buildings-box-content">
          <div className="list-wrapp daily-report">
            <div>
              <p>neka beleška</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NoteForSalesUnit;
